import { createAction, props } from "@ngrx/store";

import { ApiClient } from "../../definitions/api/api-client";
import { FailState } from "../models/fail-state";

export class ApiAccessActions {
    static readonly apiClient = {
        get: createAction("[api-access/client] get", props<{ clientId: string }>()),
        getApi: createAction("[api-access/client] get api", props<{ clientId: string }>()),
        getSuccess: createAction("[api-access/client] get success", props<ApiClient>()),
        getFail: createAction("[api-access/client] get fail", props<FailState>()),
        createClient: createAction(
            "[api-access/client] create",
            props<{ allowedAuthScopes: string[] }>()
        ),
        createClientSuccess: createAction("[api-access/client] create success", props<ApiClient>()),
        createClientFail: createAction("[api-access/client] create fail", props<FailState>()),
        removeClient: createAction("[api-access/client] remove", props<{ clientId: string }>()),
        removeClientSuccess: createAction("[api-access/client] remove success", props<{ clientId: string }>()),
        removeClientFail: createAction("[api-access/client] remove fail", props<FailState>())
    };
}